/** biome-ignore-all lint/style/useNamingConvention: camel case */
import XDate from 'xdate';
import {USER_LOGGED_IN} from '~library/organisms/LoginModal/reducer';
import {
  GREETING_CARD_E_GIFT_CHECKED_OUT,
  INIT_OFFERS,
  RESET_REVIEW,
  SET_CALC,
  SET_PAYMENT_FORM_VALIDITY,
  SET_PAYMENT_METHOD,
  SHAREABLE_LINK_PREMIUM_UPSELL,
  TOGGLE_DELIVER_CARD_NOW,
  TOGGLE_PROMO_CODE,
  UPDATE_BILLING_ZIP,
  UPDATE_CARD_CVC_FILLED,
  UPDATE_CARD_ENCRYPTED,
  UPDATE_CARD_EXP_DATE_FILLED,
  UPDATE_CARD_NUMBER_FILLED,
  UPDATE_CARD_NUMBER_LAST_FOUR,
  UPDATE_DELIVER_CARD_DATE_TIME,
  UPDATE_DELIVER_CARD_TIMEZONE,
  UPDATE_NAME_ON_CARD,
  UPDATE_REVIEW,
  UPDATE_SENDER,
} from './constants';

const dayPlusOne = XDate().addDays(1).setMinutes(0).setSeconds(0).toString('i').slice(0, 16);

const checkDateIsTodayOrBefore = (date) => Math.floor(XDate().diffDays(XDate(date))) < 0;

const getSendCardDate = (date) => {
  if (!date || checkDateIsTodayOrBefore(date)) {
    return dayPlusOne;
  }
  return date;
};

const initialState = {
  expDateFilled: false,
  cardNumberFilled: false,
  cardNumberLastFour: '',
  nameOnCard: '',
  promoCode: '',
  hasPromoCode: false,
  cardSecurityCodeFilled: false,
  billingZip: '',
  selectedOfferKey: undefined,
  offers: [],
  calc: {},
  encryptedCard: {},
  useExistingPaymentOnFile: true,
  isUpdatingPaymentCalc: false,
  orderDate: null,
  paymentMethod: '',
  eventHostName: window?.evite_event?.host_name || window?.userName,
  deliverCardNow: !window?.evite_event?.send_on,
  deliveryCardDateTime: getSendCardDate(window?.evite_event?.send_on),
  known_timezone_abbr: window?.evite_event?.known_timezone_abbr || 'PT',
  known_timezone_name: window?.evite_event?.known_timezone_name || 'America/Los_Angeles',
  checkedOut: false,
  shareableLinkPremiumUpsell: false,
  e_gift_purchase_response: {},
  amazon_url: window?.amazon_disk?.url,
  paymentFormValidity: true,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_NAME_ON_CARD:
      return {
        ...state,
        nameOnCard: action.payload,
      };
    case UPDATE_REVIEW:
      return {
        ...state,
        review: action.payload,
      };
    case UPDATE_CARD_NUMBER_LAST_FOUR:
      return {
        ...state,
        cardNumberLastFour: action.payload,
      };
    case UPDATE_CARD_ENCRYPTED:
      return {
        ...state,
        encryptedCard: {...action.payload},
      };
    case UPDATE_CARD_NUMBER_FILLED:
      return {
        ...state,
        cardNumberFilled: action.payload,
      };
    case UPDATE_CARD_EXP_DATE_FILLED:
      return {
        ...state,
        expDateFilled: action.payload,
      };
    case UPDATE_CARD_CVC_FILLED:
      return {
        ...state,
        cardSecurityCodeFilled: action.payload,
      };
    case UPDATE_BILLING_ZIP:
      return {
        ...state,
        billingZip: action.payload,
      };
    case SET_PAYMENT_FORM_VALIDITY:
      return {
        ...state,
        paymentFormValidity: !!action.payload,
      };
    case TOGGLE_PROMO_CODE:
      return {
        ...state,
        hasPromoCode: !state.hasPromoCode,
        promoCode: '',
      };
    case INIT_OFFERS:
      return {
        ...state,
        offers: [...action.payload],
      };
    case SET_CALC:
      return {
        ...state,
        billingZip: state.billingZip || action.payload?.billingPostalCode,
        calc: {...action.payload},
        offers: [...action.payload.availableOffers],
      };
    case GREETING_CARD_E_GIFT_CHECKED_OUT:
      return {
        ...state,
        e_gift_purchase_response: action.payload,
      };
    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      };
    case SHAREABLE_LINK_PREMIUM_UPSELL:
      return {
        ...state,
        shareableLinkPremiumUpsell: true,
      };

    /** GREETING CARD ACTIONS */

    case USER_LOGGED_IN:
      return {
        ...state,
        eventHostName: state.eventHostName || action.userName,
      };

    case UPDATE_SENDER:
      return {
        ...state,
        eventHostName: action.payload,
      };

    /** Toggle whether to deliver the card now */
    case TOGGLE_DELIVER_CARD_NOW: {
      if (action.payload === true) {
        return {
          ...state,
          deliverCardNow: true,
          deliveryCardDateTime: null,
          known_timezone_abbr: null,
          known_timezone_name: null,
        };
      }
      return {
        ...state,
        deliverCardNow: false,
        deliveryCardDateTime: dayPlusOne,
      };
    }
    case UPDATE_DELIVER_CARD_DATE_TIME: {
      return {
        ...state,
        deliveryCardDateTime: action.payload.formattedDate,
      };
    }
    case UPDATE_DELIVER_CARD_TIMEZONE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case RESET_REVIEW: {
      return {...initialState};
    }
    default:
      return state;
  }
}
